export function buildTolgeeUrl(baseUrl, language) {
  // Prefer shared helper if injected by wize-frontend-config
  if (window.wizecareHelpers?.buildTolgeeUrl) {
    return window.wizecareHelpers.buildTolgeeUrl(baseUrl, language);
  }
  throw new Error('wizecareHelpers.buildTolgeeUrl is not available');
}

export async function mergeTolgeeFromBase(baseUrl, language, internalTranslation) {
  // Prefer shared helper if available
  if (window.wizecareHelpers?.mergeTolgeeFromBase) {
    try {
      return await window.wizecareHelpers.mergeTolgeeFromBase(baseUrl, language, internalTranslation);
    } catch (_) {
      // fall back to local
    }
  }
  // If helper not available or disabled, return internal translation as-is (no fallback) 
  return internalTranslation;
}


